<template>
    <d-container fluid class="main-content-container px-4">
        <d-row no-gutters class="page-header py-4">
            <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
                <h3 class="page-title">Agreements</h3>
            </d-col>
        </d-row>
        <!-- Agreement Table -->
        <div class="row" v-if="checkPermission(permissionTypes.agreementRead)">
            <div class="col">
                <div class="card card-small mb-4">
                    <div class="card-header border-bottom">
                        <h6 class="m-0">Your signed agreements</h6>
                    </div>
                    <div class="card-body p-0 pb-3 text-center">
                        <agreement />
                    </div>
                </div>
            </div>
        </div>
        <no-permission-message v-else />
    </d-container>
</template>

<script>
import AgreementsTable from '@/components/table/AgreementsTable.vue';
import permissions from '../../mixins/permissions';

export default {
    mixins: [ permissions ],
    components: {
        agreement: AgreementsTable,
    },
};
</script>
